/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import Dialog from './Dialog';
import DialogBox from './DialogBox';
import DialogClose from './DialogClose';
import DialogTitle from './DialogTitle';
import styled from '@emotion/styled';

const StyledBox = styled(DialogBox)`
  max-width: 625px;
  min-height: 330px;

  label {
    font-size: 14px;
    color: ${({ theme }) => theme.gray.base};
  }

  @media only screen and (min-width: 500px) {
    padding-bottom: 24px;
  }
`;

const StyledTitle = styled(DialogTitle)`
  color: ${({ theme }) => theme.secondary.dark};
  font-size: 32px;
  font-family: ${({ theme }) => theme.fonts.algebraLight};
  font-weight: 300;
  margin-top: 16px;
  padding-right: 0;
`;

const DialogWithImage = ({ children, sources, title, ...props }) => (
  <Dialog
    {...props}
    render={({ titleId, containerProps, ...rest }) => (
      <StyledBox {...rest} {...containerProps} sources={sources}>
        {title && <StyledTitle id={titleId}>{title}</StyledTitle>}
        {children}
        <DialogClose onClick={props.onClose} />
      </StyledBox>
    )}
  />
);

DialogWithImage.propTypes = {
  children: PropTypes.any,
  duration: PropTypes.number,
  onClose: PropTypes.func.isRequired,
  show: PropTypes.bool,
  sources: PropTypes.shape({
    small: PropTypes.string.isRequired,
    large: PropTypes.string.isRequired,
  }).isRequired,
  title: PropTypes.string,
};

export default DialogWithImage;
